export const getOoredooBannerUrl = (locale: string) =>
  `https://www.ooredoo.qa/web/${locale}/qic/?utm_source=inbound&utm_medium=qic&utm_campaign=web`
